import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Image, TextInput } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToBracket, faSearch, faUser, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import /**useToast*/ 'react-native-toast-notifications';
import { useAppSelector, useAppDispatch } from '../../hooks';
import { BLink, BText /**showToast*/ } from '..';
import logo from '../../assets/images/iss_logo_dark.webp';
import { fetchAllMyEvents } from '../../store/myEvents/myEventActions';
import { fetchAllMyFavorites } from '../../store/myFavorites/myFavoritesActions';
import { themeHeader } from '../../styles';
import { validateLogon } from '../../utils/auth';
import { setRoute } from '../../store/portal/portalActions';
// import { InputRefProps } from '../Form';
import { ProfileMenu } from './profileMenu';
import { FunctionalMenus } from './functionalMenus';

export const Header = () => {
  const dispatch = useAppDispatch();
  const [rtPortal, rtUser, rtMyEvents, rtMyFav] = useAppSelector(s => [s.portal, s.user, s.myEvent, s.myFavorites]);

  const [isLogon, setIsLogon] = useState<boolean>(false);

  useEffect(() => {
    if (isLogon) {
      fetchData();
    }
  }, [isLogon]);

  useEffect(() => {
    // verify for login status
    (async () => {
      setIsLogon((await validateLogon(rtUser)) === true);
    })();
  }, [rtUser]);

  const fetchData = () => {
    if (!rtMyEvents.loaded) {
      dispatch(
        fetchAllMyEvents({
          limit: 30,
          searchParam: {},
          countToGet: 100,
        }),
      );
    }

    if (!rtMyFav.loaded) {
      dispatch(
        fetchAllMyFavorites({
          limit: 30,
          searchParam: {},
          countToGet: 100,
        }),
      );
    }
  };

  // const doSearchBtn = async () => {
  //   const searchEventName = inputSearchEvent.current?.value;

  //   if (searchEventName) {
  //     console.log('searchEventName>>>', searchEventName)
  //   }else {
  //     showToast(toast, { message: 'Please key in username and password', type: 'error' });
  //   }
  // }

  return (
    <>
      <View style={rtPortal.isSmallScreen ? themeHeader.containerSM : themeHeader.container}>
        {!rtPortal.isSmallScreen && (
          <>
            <View style={themeHeader.leftContainer}>
              <Image source={{ uri: logo }} style={themeHeader.appLogo} />
              <BLink to={{ screen: 'home' }} style={themeHeader.appTitle}>
                Booking Management
              </BLink>
            </View>

            <View style={themeHeader.middleContainer} />

            <View style={themeHeader.rightContainer}>
              {!isLogon && (
                <BLink style={themeHeader.menuItem} to={{ screen: 'login' }}>
                  <FontAwesomeIcon icon={faArrowRightToBracket} style={themeHeader.menuItemIcon} size={'xl'} />
                </BLink>
              )}
              {isLogon && <FunctionalMenus />}
              {isLogon && rtUser.user && <ProfileMenu data={rtUser.user} />}
            </View>
          </>
        )}
      </View>
      {rtPortal.isSmallScreen &&
        rtPortal.mainRoute !== 'search' &&
        rtPortal.mainRoute !== 'checkout' &&
        rtPortal.mainRoute !== 'voucher' && (
          <>
            <View style={themeHeader.leftContainer}>
              <BText style={themeHeader.appTitle}>iBooking</BText>
            </View>

            <View style={themeHeader.rightContainer}>
              <BLink
                style={themeHeader.menuItemIcon}
                to={{ screen: 'search' }}
                title="Search"
                onPress={() => dispatch(setRoute('search'))}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  style={StyleSheet.flatten([rtPortal.mainRoute === 'search' ? themeHeader.iconSelected : null])}
                  size={'lg'}
                />
              </BLink>
              <BLink
                style={themeHeader.menuItemIcon}
                to={{ screen: 'my-settings' }}
                title="Account"
                onPress={() => dispatch(setRoute('my-settings'))}
              >
                <FontAwesomeIcon
                  icon={faUser}
                  style={StyleSheet.flatten([rtPortal.mainRoute === 'my-settings' ? themeHeader.iconSelected : null])}
                  size={'lg'}
                />
              </BLink>
            </View>

            {/* <View style={themeHeader.bottom.container}>
            <FunctionalMenus isBottom={true} />
          </View> */}
          </>
        )}

      {rtPortal.isSmallScreen && rtPortal.mainRoute === 'search' && (
        <>
          <View style={themeHeader.searchContainer}>
            <BLink
              style={themeHeader.menuItemIcon}
              to={{ screen: 'home' }}
              title="Home"
              onPress={() => dispatch(setRoute('home'))}
            >
              <FontAwesomeIcon icon={faArrowLeft} style={themeHeader.menuItemIcon} size={'lg'} />
            </BLink>
            <TextInput
              id="event"
              style={themeHeader.searchTextInput}
              placeholder="Search for title, event , category"
            />
          </View>
          <View style={themeHeader.searchChipsContainer} />
        </>
      )}

      {rtPortal.isSmallScreen && rtPortal.mainRoute === 'checkout' && (
        <>
          <View style={themeHeader.searchContainer}>
            <BLink
              style={themeHeader.menuItemIcon}
              to={{ screen: 'home' }}
              title="home"
              onPress={() => dispatch(setRoute('home'))}
            >
              <FontAwesomeIcon icon={faArrowLeft} style={themeHeader.menuItemIcon} size={'lg'} />
            </BLink>
            <BText style={themeHeader.searchBackWithText}>Checkout</BText>
          </View>
          <View style={themeHeader.searchChipsContainer} />
        </>
      )}

      {rtPortal.isSmallScreen && rtPortal.mainRoute === 'voucher' && (
        <>
          <View style={themeHeader.searchContainer}>
            <BLink
              style={themeHeader.menuItemIcon}
              to={{ screen: 'checkout' }}
              title="checkout"
              onPress={() => dispatch(setRoute('checkout'))}
            >
              <FontAwesomeIcon icon={faArrowLeft} style={themeHeader.menuItemIcon} size={'lg'} />
            </BLink>
            <TextInput id="voucher" style={themeHeader.searchTextInput} placeholder="Search voucher code" />
          </View>
          <View style={themeHeader.searchChipsContainer} />
        </>
      )}
    </>
  );
};
